export const formatPrice = (price: number): string => {
  // Format price to a pretty looking string (e.g. 15000 would be '$15,000') 
  // Decimal places are hidden if they are '.00'
  const priceWithDecimal: string = price.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  return priceWithDecimal.includes('.00') ? priceWithDecimal.slice(0, -3) : priceWithDecimal;
};
